export const isEmail = (email) => {
  // as defined by RFC 5322
  const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  // selects strings that have a prefix that is not alphanumeric
  const prefixRegex = /^[^a-zA-Z0-9].*/i
  // if an email has prefix/suffix whitespace, then when trim() is called, its' length will be reduced.
  const emailHasWhitespace = (email.length !== email.trim().length)
  return emailRegex.test(email) && !(prefixRegex.test(email)) && !emailHasWhitespace
}
export const truncateFloat = (number, {min, max}) => {
  min = min || 0
  max = max || 2
  return parseFloat(number).toLocaleString('en-US', { minimumFractionDigits: min, maximumFractionDigits: max })
}

// Round a float number to the given decimal places
// e.g. roundTo(123.4567, 2) == 123.46
export const roundTo = (num, decimal) => {
  return +(Math.round(num + `e+${decimal}`) + `e-${decimal}`)
}

export const selectTextOnFocus = (event) => {
  if (event.target) event.target.select()
}



// WEBPACK FOOTER //
// ./src/utils/index.js